@if (layoutService.currentLayout() === 'form') {
  <div class="fixed ellipse1 -top-25 right-50 w-113 h-129"></div>
  <router-outlet></router-outlet>
}
@if (layoutService.currentLayout() === 'admin') {
  <div class="flex h-screen max-h-screen min-h-0">
    <div class="fixed h-screen max-h-screen min-h-0">
      <app-menu-sidebar class="top-0 bottom-0 left-0 block h-full  max-h-full min-h-0"/>
    </div>
    <div class="ms-75 grow w-full max-w-full min-w-0 flex flex-col">
      <app-header class="z-10"></app-header>
      <div class="grow h-full max-h-full min-h-0 overflow-y-auto">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
}
<p-toast position="top-center"/>
<p-confirmDialog>
  <ng-template pTemplate="headless" let-message let-onAccept="onAccept" let-onReject="onReject">
    <div class="flex flex-col gap-6 p-4">
      <div class="w-full flex">
        <div class="grow font-bold">Confirmation</div>
        <div class="cursor-pointer" (click)="confirmationService.close()">
          <i class="far fa-times text-lg"></i>
        </div>
      </div>
      <p>{{ message.message }}</p>
      <div class="flex gap-2 justify-end">
        <app-button variant="ghost" size="xs" (click)="onReject()" >Non</app-button>
        <app-button size="xs" (click)="onAccept()" variant="primary">Oui</app-button>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>

